import React, { Component } from "react";
import { css } from "glamor";
import { Select } from "antd";
import { Query } from "react-apollo";
import * as R from "ramda";
import { Tunnel } from "react-tunnels";

import { DEFAULT_PAGESIZE, DEFAULT_TASK_TYPE, TASK_LIST } from "../../config";
import { GET_TASK_PERMISSIONS, TASKS_QUERY } from "./queries";
import TasksSearchTable from "./TasksSearchTable";

const styles = {
    wrapper: css({
        margin: "1rem 0",
    }),
    loader: css({
        textAlign: "center",
        verticalAlign: "middle",
    }),
    taskType: css({
        width: 350,
    }),
};

const TasksGroup = props => (
    <Query
        query={TASKS_QUERY}
        fetchPolicy="cache-and-network"
        variables={{
            taskType: props.taskType,
            taskName: "",
            taskStatus: "",
            countryCode: "",
            linesOfBusiness: [],
            linesOfBusinessSearchOperator: "OR",
            entityName: "",
            processName: "",
            count: DEFAULT_PAGESIZE,
            cursor: null,
        }}
    >
        {apolloProps => {
            const { error } = apolloProps;
            let content = null;

            if (error) {
                content = <div>{error.message}</div>;
            } else {
                content = (
                    <TasksSearchTable
                        nameRenderer={props.nameRenderer}
                        apolloProps={apolloProps}
                        taskStatusFilterable={props.taskStatusFilterable}
                    />
                );
            }

            return <div {...styles.wrapper}>{content}</div>;
        }}
    </Query>
);

const TaskTypeFilter = props => (
    <Query query={GET_TASK_PERMISSIONS} fetchPolicy="cache-only">
        {({ loading, error, data }) => {
            if (loading || !data.permissions) return "Loading...";
            if (error) return `Error! ${error.message}`;

            const taskList = data.permissions.task.canViewAllOpen
                ? TASK_LIST
                : R.filter(task => {
                      return task[0] !== "ALLOPEN";
                  }, TASK_LIST);
            return (
                <Select
                    {...styles.taskType}
                    size="large"
                    defaultValue={DEFAULT_TASK_TYPE}
                    onChange={props.changeTaskType}
                >
                    {taskList.map(task => (
                        <Select.Option key={task[0]} value={task[0]}>
                            {task[1]}
                        </Select.Option>
                    ))}
                </Select>
            );
        }}
    </Query>
);

export class Tasks extends Component {
    state = {
        taskType: DEFAULT_TASK_TYPE,
        // dirty hack to prevent filters values caching when update apolloPaginationTable
        loading: false,
    };

    changeTaskType = taskType => {
        this.setState({ loading: true }, () => {
            this.setState({ taskType, loading: false });
        });
    };

    render() {
        return (
            <React.Fragment>
                <Tunnel id="bluebar-left-content">
                    <TaskTypeFilter changeTaskType={this.changeTaskType} />
                </Tunnel>
                {this.state.loading ? null : (
                    <TasksGroup
                        nameRenderer={this.props.nameRenderer}
                        taskType={this.state.taskType}
                    />
                )}
            </React.Fragment>
        );
    }
}
